
import { call, put, takeEvery } from 'redux-saga/effects'

import {
    clearActionType,
    createActionTypes,
    checkOperationResult,
    setOperationStart,
    setOperationError,
} from '../common/client/sagas/common';

import { GET_OPSUB_ACTION_TYPE } from './common/opsub';

import { knDataExec } from './serverApi/project';

export const GET_OPSUB_NEW_ACTION_TYPE = createActionTypes('analyze2opsub/GET_OPSUB_NEW');
export const GET_OPSUB_OLD_ACTION_TYPE = createActionTypes('analyze2opsub/GET_OPSUB_OLD');
export const ANALYZE_2_OPSUB_ACTION_TYPE = createActionTypes('analyze2opsub/ANALYZE_2_OPSUB');
export const SET_ISKN_DATE_NEW = 'analyze2opsub/SET_ISKN_DATE_NEW';
export const SET_OPSUB_ITEM_NEW = 'analyze2opsub/SET_OPSUB_ITEM_NEW';
export const SET_ISKN_DATE_OLD = 'analyze2opsub/SET_ISKN_DATE_OLD';
export const SET_OPSUB_ITEM_OLD = 'analyze2opsub/SET_OPSUB_ITEM_OLD';

export default function getActions(dispatch) {
    return {
        analyze2Opsub: (token, projectId, katuzeKod, isknDates, opsubIdOld, opsubIdNew) => dispatch({
            type: ANALYZE_2_OPSUB_ACTION_TYPE.DEFAULT,
            token, projectId, katuzeKod, isknDates, opsubIdOld, opsubIdNew,
            operation: ANALYZE_2_OPSUB_ACTION_TYPE.DEFAULT
        }),
        getOpsubNew: (token, projectId, katuzeKod, isknDate) => dispatch({
            type: GET_OPSUB_NEW_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod, isknDate,
            operation: GET_OPSUB_NEW_ACTION_TYPE.DEFAULT
        }),
        getOpsubOld: (token, projectId, katuzeKod, isknDate) => dispatch({
            type: GET_OPSUB_OLD_ACTION_TYPE.DEFAULT, token, projectId, katuzeKod, isknDate,
            operation: GET_OPSUB_OLD_ACTION_TYPE.DEFAULT
        }),
        setIsknDateNew: (isknDate) => dispatch({
            type: SET_ISKN_DATE_NEW, isknDate
        }),
        setIsknDateOld: (isknDate) => dispatch({
            type: SET_ISKN_DATE_OLD, isknDate
        }),
        setOpsubItemNew: (opsubItem) => dispatch({
            type: SET_OPSUB_ITEM_NEW, opsubItem
        }),
        setOpsubItemOld: (opsubItem) => dispatch({
            type: SET_OPSUB_ITEM_OLD, opsubItem
        })
    };
}

function* workAnalyze2Opsub(options, title, action) {
    try {
        yield call(clearActionType);
        yield call(setOperationStart, {title: title});
        yield put({type: ANALYZE_2_OPSUB_ACTION_TYPE.LOADING});
        const data = yield call(knDataExec, options.serverApi, action);
        yield put({type: ANALYZE_2_OPSUB_ACTION_TYPE.SUCCESS, data});
        yield call(checkOperationResult, data.result, {title: title});
    } catch (error) {
        yield call(setOperationError, error, ANALYZE_2_OPSUB_ACTION_TYPE);
    }
}

function* workGetOpsub(options, actionType, action) {
    try {
        yield call(clearActionType);
        yield put({type: actionType.LOADING});
        const data = yield call(
            knDataExec,
            options.serverApi,
            {
                operation: GET_OPSUB_ACTION_TYPE.DEFAULT,
                token: action.token,
                projectId: action.projectId,
                katuzeKod: action.katuzeKod,
                isknDate: action.isknDate
            }
        );
        yield put({type: actionType.SUCCESS, data});
    } catch (error) {
        yield call(setOperationError, error, actionType);
    }
}

export function* watchAnalyze2Opsub(options) {
    yield takeEvery(
        ANALYZE_2_OPSUB_ACTION_TYPE.DEFAULT, workAnalyze2Opsub, options,
        'Analýza převodů mezi vlastníky'
    );
}

export function* watchGetOpsubNew(options) {
    yield takeEvery(
        GET_OPSUB_NEW_ACTION_TYPE.DEFAULT, workGetOpsub, options, GET_OPSUB_NEW_ACTION_TYPE
    );
}

export function* watchGetOpsubOld(options) {
    yield takeEvery(
        GET_OPSUB_OLD_ACTION_TYPE.DEFAULT, workGetOpsub, options, GET_OPSUB_OLD_ACTION_TYPE
    );
}
